import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { SettingsService } from 'src/app/admin/settings/settings.service';

/**
 * Maintenance Mode page.
 *
 * @export
 * @class MaintenanceModeComponent
 * @implements {OnDestroy}
 */
@Component({
    selector: 'app-maintenance-mode',
    templateUrl: './maintenance-mode.component.html',
    standalone: false
})
export class MaintenanceModeComponent implements OnDestroy {
  /**
   * Message to show the user about why the app is in maintenance mode.
   *
   * @type {string}
   * @memberof MaintenanceModeComponent
   */
  public msg?: string;

  /**
   * Subscription for checking the maintenance mode status.
   *
   * @private
   * @type {Subscription}
   * @memberof MaintenanceModeComponent
   */
  private maintenanceModeCheckSubscription?: Subscription;

  /**
   * Creates an instance of MaintenanceModeComponent.
   *
   * @param {SettingsService} settingsService Settings service
   * @memberof MaintenanceModeComponent
   */
  constructor(
    private settingsService: SettingsService,
    private router: Router
  ) {
    this.maintenanceModeCheckSubscription = this.settingsService.checkMaintenanceMode().subscribe(x => {
      if (!x.isEnabled) {
        this.router.navigate(['/']);
      } else {
        this.msg = x.message;
      }
    });
  }

  /**
   * On component destory.
   *
   * @memberof MaintenanceModeComponent
   */
  ngOnDestroy(): void {
    if (this.maintenanceModeCheckSubscription) {
      this.maintenanceModeCheckSubscription.unsubscribe();
    }
  }
}
